import { motion } from 'framer-motion';

import HubSpotForm from '../forms/HubSpotForm';

interface JoinSectionProps {
  useInitialAnimation?: boolean;
}

const JoinSection = ({ useInitialAnimation = false }: JoinSectionProps) => {
  return (
    <section id="join" className="section bg-surface dark:bg-panel/95">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={useInitialAnimation ? { opacity: 1, x: 0 } : undefined}
            whileInView={
              !useInitialAnimation ? { opacity: 1, x: 0 } : undefined
            }
            viewport={!useInitialAnimation ? { once: true } : undefined}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-theme-primary mb-6">
              grow together
            </h2>
            <p className="text-lg text-theme-secondary mb-6">
              Join a community committed to personal growth and stronger
              relationships. Be the first to know about upcoming social events,
              learn from thought leaders, and see what fellow members are
              experiencing on their journey.
            </p>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="mr-4 p-2 bg-brand-primary/10 dark:bg-white/10 rounded-lg">
                  <svg
                    className="w-6 h-6 text-secondary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-primary dark:text-theme-primary mb-1">
                    community connection
                  </h4>
                  <p className="text-theme-secondary">
                    Be invited to community events and interactive experiences.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="mr-4 p-2 bg-brand-primary/10 dark:bg-white/10 rounded-lg">
                  <svg
                    className="w-6 h-6 text-secondary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-primary dark:text-theme-primary mb-1">
                    shared journey
                  </h4>
                  <p className="text-theme-secondary">
                    Learn from the stories and insights of thought leaders and
                    fellow members.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="mr-4 p-2 bg-brand-primary/10 dark:bg-white/10 rounded-lg">
                  <svg
                    className="w-6 h-6 text-secondary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-primary dark:text-theme-primary mb-1">
                    member perks
                  </h4>
                  <p className="text-theme-secondary">
                    Enjoy exclusive updates and offers on events, programs, and
                    tools designed to support you.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={useInitialAnimation ? { opacity: 1, x: 0 } : undefined}
            whileInView={
              !useInitialAnimation ? { opacity: 1, x: 0 } : undefined
            }
            viewport={!useInitialAnimation ? { once: true } : undefined}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-card dark:bg-panel/80 p-8 rounded-lg shadow-surface"
          >
            {/* <h3 className="text-2xl font-bold text-primary dark:text-theme-primary mb-6">
              join our community
            </h3> */}
            <HubSpotForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default JoinSection;
